const FormField = ({ label, required, children }) => (
  <div className="d-flex flex-column w-100">
    <div className="d-flex gap-2">
      <b>{label}</b> {required && <b className="text-danger">*</b>}
    </div>
    {children}
  </div>
);

export default FormField;
